import produce from 'immer';

const shuffle = (array) =>
  produce(array, (draft) => {
    let currentIndex = draft.length,
      temporaryValue,
      randomIndex;

    while (0 !== currentIndex) {
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex -= 1;

      temporaryValue = draft[currentIndex];
      draft[currentIndex] = draft[randomIndex];
      draft[randomIndex] = temporaryValue;
    }
  });

export { shuffle };
